module.exports = __webpack_public_path__ + "static/media/button-refresh.88a23001.svg";